import { Badge } from '@/view/components/ui/badge'
import { MergedSupportData } from './prepareSupportData'
import { cn } from '@/app/utils/cn'
import { SupportCategoryEnum } from '@/app/utils/supportCategoryEnum'
import { formatName } from '@/app/utils/formatName'
import masks from '@/app/utils/masks'
import { EmptyMessage } from '@/view/components/EmptyMessage'

interface BasicTableProps {
  data: MergedSupportData[]
  handleRowClick: (item: MergedSupportData) => void
  handleSheetState: () => void
}

export const TableSupport = ({
  data,
  handleRowClick,
  handleSheetState,
}: BasicTableProps) => {
  return (
    <div className="rounded-lg shadow">
      {data.length > 0 ? (
        <table className="min-w-full divide-y divide-gray-200 bg-white">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">
                Nome
              </th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-500">
                CPF
              </th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-500">
                Contrato
              </th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-500">
                Telefone
              </th>
              <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">
                Tipo
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((item) => (
              <tr
                key={item._id}
                className="cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  handleRowClick(item)
                  handleSheetState()
                }}
              >
                <td className="whitespace-nowrap px-6 py-4">
                  {item.name.length === 1
                    ? formatName(item.name[0])
                    : item.name.map((n) => <p key={n}>{formatName(n)}</p>)}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-center">
                  {item.cpf.length === 1
                    ? masks.cpf(item.cpf[0])
                    : item.cpf.map((c) => <p key={c}>{masks.cpf(c)}</p>)}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-center">
                  {item.contract ? item.contract : '-'}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-center">
                  {item.phone.length === 1
                    ? masks.phone(item.phone[0])
                    : item.phone.map((p) => <p key={p}>{masks.phone(p)}</p>)}
                </td>
                <td className="flex justify-end whitespace-nowrap px-6 py-4">
                  <Badge
                    variant="outline"
                    className={cn(
                      'flex w-20 items-center justify-center rounded-lg text-[10px]',
                      `${item.type === SupportCategoryEnum.CUSTOMER && 'text-success'}`,
                      `${item.type === SupportCategoryEnum.USER && 'text-info'}`,
                      `${item.type === SupportCategoryEnum.TRANSACTION && 'text-error'}`,
                    )}
                  >
                    {item.type === SupportCategoryEnum.CUSTOMER && 'Cliente'}
                    {item.type === SupportCategoryEnum.USER && 'Vendedor'}
                    {item.type === SupportCategoryEnum.TRANSACTION &&
                      'Proposta'}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyMessage title="Sem resultados encontrados para essa pesquisa" />
      )}
    </div>
  )
}
